// extracted by mini-css-extract-plugin
module.exports = {"root":"DepositFormIframeScript_root__Op1yZ","frameWrapper":"DepositFormIframeScript_frameWrapper__H5RNO"};